import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Row, Col, Button } from 'react-bootstrap';
import { Formik, Form, FormikHelpers } from 'formik';
import DataTable from 'react-data-table-component';
import { FormGroupControl } from '@components/Base';
import { sleep } from '@utils/promise';
import { formValuesSchema, FormValues } from './schema';
import { useColumns } from '../view';
import { corporateHealthOrderUserFetch } from '../action';
import { selectSearchCorporateMember } from '../selector';

const GROUP_PROPS = { className: 'mb-3' };
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
    },
  },
};

const SearchFormHospitalUser = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const columns = useColumns();
  const { corporateHealthOrderUser, isLoading } = useSelector(selectSearchCorporateMember);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  const handleSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    await sleep(1000);
    dispatch(corporateHealthOrderUserFetch(values));
    setSubmitting(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={formValuesSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Row>
            <Col>
              <FormGroupControl required name="name" label={t('user.name')} groupProps={GROUP_PROPS} />
            </Col>
            <Col>
              <FormGroupControl
                required
                name="policyNumber"
                label={t('common:policyNumber')}
                groupProps={GROUP_PROPS}
              />
            </Col>
            <Col>
              <div style={{ marginTop: 30 }}>
                <Button type="submit" variant="primary" disabled={isSubmitting}>
                  {t('common:search')}
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <DataTable
                columns={columns}
                data={isEmpty(corporateHealthOrderUser) ? [] : [corporateHealthOrderUser]}
                customStyles={customStyles}
                fixedHeader
                progressPending={isLoading}
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export { SearchFormHospitalUser };
